import React from "react";
import toast from "react-hot-toast";
import { X, Check, Info } from "lucide-react";

const createToastContent = (message: string, id: string, type: "success" | "error" | "info") => {
  let leftIcon;

  if (type === "error") {
    leftIcon = React.createElement(
      "button",
      {
        type: "button",
        onClick: (e: React.MouseEvent) => {
          e.stopPropagation();
          toast.dismiss(id);
          toast.remove(id);
        },
        title: "Dismiss",
        style: {
          background: "#fff",
          border: "none",
          cursor: "pointer",
          color: "#f44336",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          padding: "3px",
          marginRight: "8px",
          flexShrink: 0,
          transition: "transform 0.2s",
        },
        onMouseEnter: (e: React.MouseEvent) => {
          (e.currentTarget as HTMLButtonElement).style.transform = "scale(1.15)";
        },
        onMouseLeave: (e: React.MouseEvent) => {
          (e.currentTarget as HTMLButtonElement).style.transform = "scale(1)";
        },
      },
      React.createElement(X, { size: 12, strokeWidth: 3 })
    );
  } else if (type === "success") {
    leftIcon = React.createElement(
      "button",
      {
        type: "button",
        onClick: (e: React.MouseEvent) => {
          e.stopPropagation();
          console.log("Dismissing success toast:", id);
          toast.dismiss(id);
          toast.remove(id);
        },
        title: "Dismiss",
        style: {
          background: "#fff",
          border: "none",
          cursor: "pointer",
          color: "#4caf50",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          padding: "3px",
          marginRight: "8px",
          flexShrink: 0,
          transition: "transform 0.2s",
        },
        onMouseEnter: (e: React.MouseEvent) => {
          (e.currentTarget as HTMLButtonElement).style.transform = "scale(1.15)";
        },
        onMouseLeave: (e: React.MouseEvent) => {
          (e.currentTarget as HTMLButtonElement).style.transform = "scale(1)";
        },
      },
      React.createElement(Check, { size: 12, strokeWidth: 3 })
    );
  } else {
    leftIcon = React.createElement(
      "button",
      {
        type: "button",
        onClick: (e: React.MouseEvent) => {
          e.stopPropagation();
          console.log("Dismissing info toast:", id);
          toast.dismiss(id);
          toast.remove(id);
        },
        title: "Dismiss",
        style: {
          background: "#fff",
          border: "none",
          cursor: "pointer",
          color: "#2196f3",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          padding: "3px",
          marginRight: "8px",
          flexShrink: 0,
          transition: "transform 0.2s",
        },
        onMouseEnter: (e: React.MouseEvent) => {
          (e.currentTarget as HTMLButtonElement).style.transform = "scale(1.15)";
        },
        onMouseLeave: (e: React.MouseEvent) => {
          (e.currentTarget as HTMLButtonElement).style.transform = "scale(1)";
        },
      },
      React.createElement(Info, { size: 12, strokeWidth: 3 })
    );
  }

  return React.createElement(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        width: "100%",
      },
    },
    leftIcon,
    React.createElement("span", { style: { flex: 1 } }, message)
  );
};

export const showSuccess = (message: string) => {
  toast.success((t) => createToastContent(message, t.id, "success"), {
    duration: 2000,
    icon: null,
    style: {
      borderRadius: "8px",
      background: "#4caf50",
      color: "#fff",
      minWidth: "250px",
    },
  });
};

export const showError = (message: string, status_code?: number) => {
  const displayMessage = status_code === 403 ? "Unauthorized access" : message;

  toast.error((t) => createToastContent(displayMessage, t.id, "error"), {
    duration: 5000,
    icon: null,
    style: {
      borderRadius: "8px",
      background: "#f44336",
      color: "#fff",
      minWidth: "250px",
    },
  });
};

export const showInfo = (message: string) => {
  toast((t) => createToastContent(message, t.id, "info"), {
    duration: 3000,
    icon: null,
    style: {
      borderRadius: "8px",
      background: "#2196f3",
      color: "#fff",
      minWidth: "250px",
    },
  });
};
